/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Product Reviews functionality
define('modules/Reviews/ProductReviews',[
    'jquery',
    'global/all',
    './Reviews',
    './ProductReviews.Forms',
    'modules/AddThis/AddThisLoader',
    'modules/User/all',
    'plugins/jquery.rateit.min'
], function ($, Roc, Reviews, ProductReviewsForms, AddThis, Users) {
    'use strict';

    var currentProductId;
    var pageSize;
    var page;
    var sortBy;
    var sortType;
    var totalPages;
    var totalReviews;
    var rocUrl;
    var automaticPublishEnabled = false;
    var isLocked = false;
    var signInUrl;

    var btns = {
        submitReview: '[data-roc-action="submitReview"]',
        cancelReview: '[data-roc-action="cancelReview"]',
        submitComment: '[data-roc-action="submitComment"]'
    };

    function clearReviewsForm() {
        $('#writeReviewRateit').rateit('value', null);
        $('#reviewWrite').val('');
        $('#location').val('');
        $('#recommendYes').prop('checked', true);
        if ($('#writeTitle').is(':visible')) {
            $('#writeTitle').val('');
        }   
    }

    function clearAddCommentFields(index) {
        $('#commentName' + index).val('');
        $('#commentWrite' + index).val('');
    }
    
    function generateErrorsFromFailureResponse(response, $element) {
        // handle BadRequest and ModelState errors
        var errorModel = {
            id: 'reviewErrors',
            errors: Roc.Core.getModelStateErrors(response)
        };

        Roc.UI.template('errorBox-Tmp', errorModel).then(function (renderedTemplate) {
            $element.prepend(renderedTemplate);
        });
    }

    function refreshControls() {
        totalReviews = parseInt($('#reviewList').find('.totalReviewsCount').text());
        if (totalReviews === 0) {
            $('.reviewsWrapper .reviewAverage, .reviewsWrapper #reviewList').hide();
            //$('.reviewsWrapper').removeClass('contentBoxInterior');
            $('.noReviewsWrapper').show();
        } else {
            $('#reviewSort option[data-sortby=' + sortBy + '][data-sorttype=' + sortType + ']').prop('selected', true);
            $('#reviewSort2 option[data-sortby=' + sortBy + '][data-sorttype=' + sortType + ']').prop('selected', true);
            $('#reviewList .paging input[type="number"]').val(page);
            totalPages = parseInt($('#reviewList .pagination .paging .total').data('totalpages'));
            $('.noReviewsWrapper').hide();
            //$('.reviewsWrapper').addClass('contentBoxInterior');
            $('.reviewsWrapper .reviewAverage, .reviewsWrapper #reviewList').show();
        }
    };

    function refreshReviewsList() {
        var defer = $.Deferred();
        $.get('', { 'pageSize': pageSize, 'page': page, 'sortBy': sortBy, 'sortType': sortType, 'forceRefresh': true }, function (data) {
            $('#reviewList .reviewItem').remove();
            $('#reviewList .reviewItem', data).not('.reviewComment').insertBefore($('#reviewList > .clearfix:last'));
            $('.ratingBreakdown').html($('.ratingBreakdown', data).html());
            $('.ratingSummary').html($('.ratingSummary', data).html());
            $('#reviewsWrapper [itemprop="aggregateRating"]').find('.ratingDisplay').replaceWith($('.reviewAverageInterior', data).find('.ratingDisplay'));
            if ($('.reviewItem.reviewMini').length > 0) {
                $('.reviewItem.reviewMini .ratingDisplay .rateit').replaceWith($('.reviewAverageInterior', data).find('.ratingDisplay .rateit'));
                $('.reviewItem.reviewMini a.jumpToReview:first').text($('[itemprop="reviewCount"]').html() + ' reviews');
            }
            $('.rateit').rateit();
            $('#reviewList .pagination.clearfix').eq(0).html($('#reviewList .pagination.clearfix:eq(0)', data).html());
            $('#reviewList > .clearfix:last').html($('#reviewList > .clearfix:last', data).html());

            $('#reviewList .roc-pageOptions').html($('#reviewList .roc-pageOptions', data).html());
            $('#reviewList .roc-pageOptions-count').html($('#reviewList .roc-pageOptions-count', data).html());

            //TODO: Check expection details:
            //http://m.addthis.com/live/red_lojson/300lo.json?uk2qv5&colc=1448289337007&si=5653243897030654&uid=55362e147b43695b&pub=ameaglecom&rev=v3.4.1-wp&jsl=1&ln=en&pc=men&vpc=&dp=localhost%3A3001&fp=products%2Fabtest4%2F&of=0&uf=0&pd=0&irt=0&md=0&ct=1&tct=0&abt=0&lt=133&cdn=0&lnlc=US&tl=c%3D35%2Cm%3D41%2Ci%3D71%2Cxm%3D197%2Cxp%3D200&pi=1&&rb=0&gen=100&callback=_ate.track.hsr&uvs=565317e16eb7a8bf01a&chr=UTF-8&vcl=3
            if (window.addthis) {
                window.addthis.button('.addthis_button_compact');
                $('.addthis_button_compact').addClass('at300m');
            }

            Reviews.truncateDescriptions();
            refreshControls();
            defer.resolve();
        }).fail(function() {
            defer.reject();
        });

        return defer.promise();
    }

    /*  Events        */

    function getReviewId(element) {
        return $(element).parents('.itemRoot').attr('data-id');
    }

    function postReviewEvt() {
        $(document).on('click', btns.submitReview, function (e) {
            if (!isLocked) {
                if (!Roc.Validation.validateForm(ProductReviewsForms.WriteReview)) {
                    return false;
                }

                $('#reviewErrors').remove();
                Roc.Core.lockButton(btns.submitReview);
                isLocked = true; //use isLocked variable to prevent from invoking actions concurrently

                var requestData = {
                    productId: currentProductId,
                    rating: $('#write-review-rating').val(),
                    name: $('#writeAuthor').val(),
                    description: $('#reviewWrite').val(),
                    title: $('#writeTitle').val(),
                    location: $('#location').val(),
                    isRecomended: null
                };

                if ($('#recommendYes').is(':checked')) {
                    requestData.isRecomended = true;
                } else if ($('#recommendNo').is(':checked')) {
                    requestData.isRecomended = false;
                }

                $.ajax({
                    type: 'POST',
                    url: rocUrl + '/api/productreview',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json'

                }).done(function (successResponse) {
                    if (automaticPublishEnabled) {
                        refreshReviewsList();
                    } else {
                        var viewModel = {
                            id: 'reviewThankYou',
                            title: 'Thank you for submitting your review',
                            content: 'It will appear when it is approved.'
                        };

                        Roc.UI.template('infoBox-Tmp', viewModel).then(function (renderedTemplate) {
                            $('#reviewsWrapper .reviewCompose').append(renderedTemplate);
                            $('#' + viewModel.id).focus();
                        });
                    }

                    Reviews.hideWriteReview();
                    clearReviewsForm();
 
                    Roc.EventManager.notify(Roc.Events.reviews.WRITE_RATE, 
                        { "productId": requestData.productId, "rating": requestData.rating });

                }).fail(function (failResponse) {
                    generateErrorsFromFailureResponse(failResponse, $('#writeReview'));
                }).always(function () {
                    Roc.Core.releaseLockedButton(btns.submitReview);
                    isLocked = false; //always unblock reviews js controller
                });

                return false;
            }
        });
    }

    function cancelReviewEvt() {
        $(document).on('click', btns.cancelReview, function () {
            clearReviewsForm();
            Roc.Forms.clearData(ProductReviewsForms.WriteReview);
            Roc.UI.clearFormErrors(ProductReviewsForms.WriteReview);
        });
    }

    function markReviewAsHelpful(reviewId, isHelpful) {
        var requestData = {
            rocId: reviewId,
            isHelpful: isHelpful
        };

        return $.ajax({
            type: 'PUT',
            url: rocUrl + '/api/productreview/mark-helpful',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        });
    }

    function markReviewAsHelpfulEvt() {
        $(document)
            .off('click', '[data-isHelpful]')
            .on('click', '[data-isHelpful]', function () {
                var reivewListId = $(this).attr('data-review-id');
                var selector = '.reviewHelpful[data-review-id=' + reivewListId + ']';
                var reviewId = getReviewId(this);
                var isHelpful = $(this).attr('data-isHelpful') === 'true';

                if (!Users.isLoggedIn()) { // if user is not logged in, redirect to sign-in page
                    var redirectBackUrl = Roc.UrlHelper.buildCurrentUrlWithQueryString({
                        'action': 'markReviewAsHelpful',
                        'reviewId': reviewId,
                        'isHelpful': isHelpful
                    });
                    var redirectToUrl = Roc.UrlHelper.buildRedirectUrl(signInUrl, redirectBackUrl);
                    window.location.href = redirectToUrl;
                    return;
                }

                // block the review div
                Roc.UI.block(selector);
                markReviewAsHelpful(reviewId, isHelpful).then(
                    function () {
                        refreshReviewsList().always(
                            function () {
                                isLocked = false; //always unblock reviews js controller
                                Roc.UI.unblock(selector);
                            });
                    }, function() {
                        Roc.UI.displayErrorPopup('Failed to mark review');
                        isLocked = false; //always unblock reviews js controller
                    });
            });
    }

    function reportReviewToAdminEvt() {
        $(document).on('click', '.reportAbuseReview', function () {
            var requestData = {
                rocId: getReviewId(this),
                userId: Roc.Core.getCookie('UserId')
            };

            $.ajax({
                type: 'PUT',
                url: rocUrl + '/api/productreview/report-to-administrator',
                data: JSON.stringify(requestData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            }).done(function (successResponse) {
                refreshReviewsList();
                Roc.UI.info('Review was reported to administrator');
            }).fail(function (failResponse) {
                Roc.UI.displayErrorPopup('Failed to report review abuse');
            }).always(function () {
                isLocked = false; //always unblock reviews js controller
            });

            return false;
        });
    };

    function reportCommentToAdminEvt() {
        $(document).on('click', '.reportAbuseComment', function () {
            var requestData = {
                rocId: getReviewId(this),
                userId: Roc.Core.getCookie('UserId')
            };

            $.ajax({
                type: 'PUT',
                url: rocUrl + '/api/productreview/comment/report-to-administrator',
                data: JSON.stringify(requestData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
            }).done(function (successResponse) {
                refreshReviewsList();
                Roc.UI.info('Comment was reported to administrator');
            }).fail(function (failResponse) {
                Roc.UI.displayErrorPopup('Failed to report comment abuse');
                Roc.Logger.error(JSON.parse(failResponse.responseJSON));
            }).always(function () {
                isLocked = false; //always unblock reviews js controller
            });

            return false;
        });
    };

    function addCommentToReviewEvt() {
        $(document).on('click', btns.submitComment, function (e) {
            e.preventDefault();

           var commentForm = {
                Fields: [
                    {
                        'Name': 'Name',
                        'Field': '#commentName0',
                        'Param': 'name',
                        'Type': 'Text'
                    },
                    {
                        'Name': 'Leave a Comment',
                        'Field': '#commentWrite0',
                        'Param': 'comment',
                        'Type': 'Textarea'
                    }
                ],
                Validate: true
            };

            if (!isLocked) {
                if (!Roc.Validation.validateForm(commentForm)) {
                    return false;
                }

                $('#reviewErrors').remove();
                Roc.Core.lockButton(btns.submitComment);
                isLocked = true;

                var index = $(this).attr('data-index');
                var requestData = {
                    commentContent: $('#commentWrite' + index).val(),
                    reviewId: getReviewId(this),
                    userName: $('#commentName' + index).val()
                };

                $.ajax({
                    type: 'POST',
                    url: rocUrl + '/api/productreview/comment',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json'
                }).done(function (successResponse) {
                    if (automaticPublishEnabled) {
                        refreshReviewsList();
                    } else {
                        var viewModel = {
                            id: 'reviewThankYou',
                            title: 'Thank you for submitting your comment',
                            content: 'It will appear when it is approved.'
                        };

                        Roc.UI.template('infoBox-Tmp', viewModel).then(function (renderedTemplate) {
                            $('#commentCompose_' + index).html(renderedTemplate);
                            $('#' + viewModel.id).focus();
                        });
                    }

                    clearAddCommentFields(index);
                }).fail(function (failResponse) {
                    generateErrorsFromFailureResponse(failResponse, $('#commentCompose_' + index));
                }).always(function () {
                    Roc.Core.releaseLockedButton(btns.submitComment);
                    isLocked = false; //always unblock reviews js controller
                });
            }
        });
    };

    function onKeyDownEvt() {
        $(document).on('keydown', function (e) {
            var $target = e.target;
            $('#reviewList .paging input').each(function (data) {
                if ($(this)[0] === $target && e.keyCode === 13) {
                    e.preventDefault();
                    var refresh = false;
                    if ($(this).val() < 1) {
                        $(this).val(1);
                        refresh = true;
                    } else if ($(this).val() > totalPages) {
                        $(this).val(totalPages);
                        refresh = true;
                    }
                    if (refresh) {
                        page = $(this).val();
                        refreshReviewsList();
                    }
                    $(this).trigger('blur');
                    return false;
                }
            });
        });
    };

    function sortChangeEvt() {
        $(document).on('change', '#reviewSort', function () {
            var optionSelected = $('option:selected', this);
            sortBy = optionSelected.attr('data-sortBy');
            sortType = optionSelected.attr('data-sortType');
            refreshReviewsList();
        });
    }

    function pageNumChangeEvt() {
        $(document).on('change', '#reviewList .pagination .pageNum', function () {
            var pageNum = parseInt($(this).val());
            if (pageNum > 0 && pageNum <= totalPages) {
                page = pageNum;
                refreshReviewsList();
            } else {
                $('#reviewList .paging input[type="number"]').val(page);
            }
        });
    }

    function pagination(pageNum) {
        pageNum = parseInt(pageNum);
        if (pageNum > 0 && pageNum <= totalPages) {
            page = pageNum;
            refreshReviewsList();
        }
    };

    function prevPageEvt() {
        $(document).on('click', '#reviewList .pagination .prev', function (e) {
            e.preventDefault();
            var pageNum = page - 1;
            pagination(pageNum);
        });
    }

    function nextPageEvt() {
        $(document).on('click', '#reviewList .pagination .next', function (e) {
            e.preventDefault();
            var pageNum = page + 1;
            pagination(pageNum);
        });
    }

    function actionOnLoad() {
        var action = Roc.UrlHelper.getQueryStringParameterByName('action');
        if (action === null || action === '') {
            return;
        }

        switch (action) {
            case 'markReviewAsHelpful':
                var reviewId = Roc.UrlHelper.getQueryStringParameterByName('reviewId');
                var isHelpful = Roc.UrlHelper.getQueryStringParameterByName('isHelpful');
                if (reviewId === null || reviewId === '' || isHelpful === null || isHelpful === '' || !Users.isLoggedIn()) {
                    return;
                }

                var reviewsSelector = '#reviewsWrapper';
                var animationProps = {
                    scrollTop: ($(reviewsSelector).offset().top - 60)
                };

                $('html, body')
                    .animate(animationProps, 500)
                    .promise().then(function () {
                        isLocked = true;
                        Roc.UI.block(reviewsSelector);
                        markReviewAsHelpful(reviewId, isHelpful).then(function () {
                            Roc.UI.unblock(reviewsSelector);
                            refreshReviewsList().always(function () {
                                Roc.UI.unblock(reviewsSelector);
                                Roc.UI.success('Thank you for your feedback!');
                            });
                        }, function () {
                            Roc.UI.unblock(reviewsSelector);
                        });
                    });
                break;
        }
    }

    function bindEvents() {
        $('form').submit(function (e) {
            e.preventDefault();
        });
        onKeyDownEvt();
        postReviewEvt();
        cancelReviewEvt();
        markReviewAsHelpfulEvt();
        sortChangeEvt();
        prevPageEvt();
        nextPageEvt();
        pageNumChangeEvt();
        reportReviewToAdminEvt();
        reportCommentToAdminEvt();
        addCommentToReviewEvt();
        actionOnLoad();
    };

    function init(initData) {
        currentProductId = initData.currentProductId;
        pageSize = initData.pageSize;
        page = initData.page;
        sortBy = initData.sortBy;
        sortType = initData.sortType;
        totalPages = initData.totalPages;
        totalReviews = initData.totalReviews;
        rocUrl = initData.rocUrl;
        signInUrl = initData.signInUrl;

        Reviews.init();
        bindEvents();
        refreshControls();

        $.getJSON(rocUrl + '/api/productreview/publishingoption', function (response) {
            if (response) {
                automaticPublishEnabled = response.automaticPublishEnabled;
            }
        });
    };

    var ProductReviews = {
        init: init
    };

    Roc.Logger.debug('ProductReviews.js Loaded:', ProductReviews);

    return ProductReviews;
});
